import { FEATURES } from "const/feature/const";
// 루트
export const ROUTE_ROOT = "/";
// 로그인
export const ROUTE_SERVICE_UNAVAILABLE = "/service-unavailable";
// 로그인
export const ROUTE_LOGIN = "/login";
// 인증 콜백
export const ROUTE_AUTH_CALLBACK = "/auth-callback";
// 라이브러리
export const ROUTE_LIBRARY = "/library";

export const ROUTE_LIBRARY_DATASETS = `${ROUTE_LIBRARY}/datasets`; // All, dataset-only
export const ROUTE_LIBRARY_DATASOURCES = `${ROUTE_LIBRARY}/data-sources`;
export const ROUTE_LIBRARY_LOGS = `${ROUTE_LIBRARY}/logs`;

export const ROUTE_MART = "/mart";
export const ROUTE_MART_ANSWERSET = `${ROUTE_MART}/answersets`;
export const ROUTE_MART_LOGS = `${ROUTE_MART}/logs`;

export const ROUTE_MANUAL = "/manual";

// 프로젝트
export const ROUTE_PROJECT = "/project";

export const ROUTE_PROJECT_LIST = `${ROUTE_PROJECT}/list`;
export const ROUTE_PROJECT_DATA = `${ROUTE_PROJECT}/:PROJECT_ID`;

export const ROUTE_PROJECT_JUPYTER = `${ROUTE_PROJECT}/jupyter`;

// apf
export const ROUTE_FLOW = "/flow";
export const ROUTE_FLOW_FLOWS = `${ROUTE_FLOW}/flows`;
export const ROUTE_FLOW_GROUPS = `${ROUTE_FLOW}/groups`;
export const ROUTE_FLOW_LOGS = `${ROUTE_FLOW}/logs`;

// 리포트
export const ROUTE_REPORT = "/report";

export const ROUTE_REPORT_LIST = `${ROUTE_REPORT}/list`;
export const ROUTE_REPORT_DATA = `${ROUTE_REPORT}/:REPORT_ID`;

// 유저관리
export const ROUTE_ADMIN = "/admin";

export const ROUTE_ADMIN_USERS = `${ROUTE_ADMIN}/users`;
export const ROUTE_ADMIN_GROUPS = `${ROUTE_ADMIN}/groups`;
export const ROUTE_ADMIN_ROLES = `${ROUTE_ADMIN}/roles`;
export const ROUTE_ADMIN_CONNECTORS = `${ROUTE_ADMIN}/connectors`;
export const ROUTE_ADMIN_DOMAINS = `${ROUTE_ADMIN}/domains`;
export const ROUTE_ADMIN_USER_LOGS = `${ROUTE_ADMIN}/userLogs`;
export const ROUTE_ADMIN_MONITORING = `${ROUTE_ADMIN}/monitoring`;
export const ROUTE_ADMIN_SETTINGS = `${ROUTE_ADMIN}/settings`;

// 리포트
export const ROUTE_EXTERNAL = "/external";
export const ROUTE_EXTERNAL_JUPYTER = `${ROUTE_EXTERNAL}/jupyter`;
